import React from 'react';
import { ImagePlaceholder } from './ImagePlaceholder';
import { BrandButton } from './BrandButton';
interface CollectionCardProps {
  name: string;
  tagline: string;
  description?: string;
  pieces?: string[];
  priceRange?: string;
  imageLabel: string;
  badge?: string;
  shopUrl: string;
  withStripe?: boolean;
}
export function CollectionCard({
  name,
  tagline,
  description,
  pieces,
  priceRange,
  imageLabel,
  badge,
  shopUrl,
  withStripe = false
}: CollectionCardProps) {
  return <div className="group relative flex flex-col h-full bg-[#F8C8DC] bg-opacity-20 rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-[#F0D0E0]" data-id="element-165">
      <div className="relative" data-id="element-166">
        <ImagePlaceholder label={imageLabel} aspectRatio="square" className="rounded-none border-0 border-b border-[#F8C8DC]" data-id="element-167" />
        {badge && <div className="absolute top-4 right-4 bg-[#F5D76E] text-[#6B1D4A] text-xs font-bold px-3 py-1.5 rounded-full shadow-sm font-body uppercase tracking-wider" data-id="element-168">
            {badge}
          </div>}
      </div>

      <div className="flex flex-col flex-grow p-6 md:p-8" data-id="element-169">
        <h3 className="font-heading text-2xl font-bold text-[#2D1A1A] mb-1" data-id="element-170">
          {name}
        </h3>
        <p className="font-script text-xl text-[#E91E8C] mb-4" data-id="element-171">{tagline}</p>

        {description && <p className="font-body text-[#2D1A1A] opacity-80 mb-4" data-id="element-172">
            {description}
          </p>}

        {pieces && pieces.length > 0 && <div className="mb-6 flex-grow" data-id="element-173">
            <h4 className="font-body font-bold text-[#6B1D4A] text-sm uppercase tracking-wider mb-2" data-id="element-174">
              Included Pieces
            </h4>
            <ul className="space-y-1" data-id="element-175">
              {pieces.map((piece, idx) => <li key={idx} className="font-body text-sm text-[#2D1A1A] flex items-start" data-id="element-176">
                  <span className="text-[#E91E8C] mr-2" data-id="element-177">✦</span>
                  {piece}
                </li>)}
            </ul>
          </div>}

        <div className="mt-auto pt-6 border-t border-[#F8C8DC] border-opacity-50" data-id="element-178">
          {priceRange && <p className="font-body font-medium text-[#6B1D4A] mb-4" data-id="element-179">
              {priceRange}
            </p>}
          <BrandButton href={shopUrl} external variant="primary" className="w-full" data-id="element-180">
            Shop Collection
          </BrandButton>
        </div>
      </div>
    </div>;
}